import AR_1 from "./ActivistPictures/AR-Pic-1.jpg";
import AR_2 from "./ActivistPictures/AR-Pic-2.jpg";
import AR_3 from "./ActivistPictures/AR-Pic-3.jpg";
import AR_4 from "./ActivistPictures/AR-Pic-4.jpg";
import AR_5 from "./ActivistPictures/AR-Pic-5.jpg";

import Recent_1 from "./ActivistPictures/Recents-Pic-1.jpg";
import Recent_2 from "./ActivistPictures/Recents-Pic-2.jpg";
import Recent_3 from "./ActivistPictures/Recents-Pic-3.jpg";
import Recent_4 from "./ActivistPictures/Recents-Pic-4.jpg";
import Recent_5 from "./ActivistPictures/Recents-Pic-5.jpg";
import Recent_6 from "./ActivistPictures/Recents-Pic-6.jpg";

import old_1 from "./ActivistPictures/Old-Pic-1.jpg";
import old_2 from "./ActivistPictures/Old-Pic-2.jpg";
import old_3 from "./ActivistPictures/Old-Pic-3.jpg";
import old_4 from "./ActivistPictures/Old-Pic-4.png";
import old_5 from "./ActivistPictures/Old-Pic-5.jpg";
import old_6 from "./ActivistPictures/Old-Pic-6.jpg";

export const ActivistPhotoContent = [
  {
    id: 1,
    title: "AR",
    latestPicture: {
      image: AR_4,
      date: "2 May 2023",
      time: "12:26 PM",
      location: "California",
    },
    pictures: [
      {
        image: AR_4,
        date: "2 May 2023",
        time: "12:26 PM",
        location: "California",
      },
      {
        image: AR_5,
        date: "16 August 2023",
        time: "4:43 PM",
        location: "California",
      },
      {
        image: AR_3,
        date: "5 January 2024",
        time: "9:47 AM",
        location: "California",
      },
      {
        image: AR_1,
        date: "3 March 2024",
        time: "3:16 PM",
        location: "California",
      },
      {
        image: AR_2,
        date: "22 March 2024",
        time: "6:01 PM",
        location: "California",
      },
    ],
  },
  {
    id: 2,
    title: "Recent",
    latestPicture: {
      image: Recent_1,
      date: "2 September 2023",
      time: "5:45 PM",
      location: "California",
    },
    pictures: [
      {
        image: Recent_1,
        date: "2 September 2023",
        time: "5:45 PM",
        location: "California",
      },
      {
        image: Recent_2,
        date: "3 September 2023",
        time: "3:08 PM",
        location: "California",
      },
      {
        image: Recent_3,
        date: "8 January 2024",
        time: "1:47 PM",
        location: "California",
      },
      {
        image: Recent_4,
        date: "14 January 2024",
        time: "4:55 PM",
        location: "California",
      },
      {
        image: Recent_5,
        date: "11 March 2024",
        time: "9:13 AM",
        location: "California",
      },
      {
        image: Recent_6,
        date: "27 February 2024",
        time: "10:39 AM",
        location: "Home, San Amaro ",
      },
    ],
  },

  {
    id: 3,
    title: "Old",
    latestPicture: {
      image: old_1,
      date: "17 July 1993",
      time: "2:35 PM",
      location: "New Jersey",
    },
    pictures: [
      {
        image: old_1,
        date: "17 July 1993",
        time: "2:35 PM",
        location: "New Jersey",
      },
      {
        image: old_2,
        date: "2 August 2007",
        time: "10:07 AM",
        location: "New Jersey",
      },
      {
        image: old_3,
        date: "15 August 2009",
        time: "3:50 AM",
        location: "Nepal",
      },
      {
        image: old_4,
        date: "10 September 2011",
        time: "1:44 PM",
        location: "Nepal",
      },
      {
        image: old_5,
        date: "27 September 2011",
        time: "6:14 AM",
        location: "Nepal",
      },
      {
        image: old_6,
        date: "15 April 2013",
        time: "4:41 PM",
        location: "Canada ",
      },
    ],
  },
];
